import {register, SwiperContainer} from 'swiper/element/bundle';
import { Swiper } from 'swiper/types';
import {contentSliderStyles} from "@/components/content-slider/content-slider.styles.ts";
import {leadmanagementSliderStyles} from "@/components/leadmanagement-slider/leadmanagement-slider.styles.ts";
import '@/components/oip-benefit/oip-benefit.ts';
import '@/components/hero-slide/hero-slide.ts';
import '@/components/leadmanagement-slider/leadmanagement-slider.scss';
import {heroSliderStyles} from "@/components/hero-slider/hero-slider.styles.ts";
import {sbkCoreBreakpointXl} from "@/tokens/variables";



const SbkLeadmanagementSlider = {
    initialize() {
        register();
        const swiperElements: NodeListOf<SwiperContainer> = document.querySelectorAll('[variant="leadmanagement"]');
        const viewWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        swiperElements.forEach((swiperElement) => {
            const params = {
                a11y: true,
                navigation: viewWidth >= parseInt(sbkCoreBreakpointXl.replace("px","")) ? {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                } : true,
                pagination: viewWidth >= parseInt(sbkCoreBreakpointXl.replace("px","")) ? false : {
                    type: 'custom',
                    renderCustom: function (_swiper: SwiperContainer, current: string, total: string) {
                        current = Number(current) < 10 ? '0' + current : current;
                        total = Number(total) < 10 ? '0' + total : total;
                        return '<span><b>' + current + '</b></span><span>' + '/' + '</span><span>' + total + '</span>';
                    }
                },
                injectStyles: [
                    contentSliderStyles,
                    heroSliderStyles,
                    leadmanagementSliderStyles
                ],
                initialSlide: parseInt(swiperElement.dataset.initialSlide ?? '1'),
                slidesPerView: 1,
                on: {
                    init: (swiper: Swiper) => {
                        this.updateSliderNavigation(swiper);
                    },
                    slideChange: (swiper: Swiper) => {
                        this.updateSliderNavigation(swiper)
                    }
                },
            };
            Object.assign(swiperElement, params);
            swiperElement.initialize();
        });
    },
    updateSliderNavigation(swiper: Swiper) {
        const currentSlide = swiper.activeIndex + 1;
        const slidesCount = swiper.slides.length;
        const nextSlideButton: HTMLElement|null = document.querySelector('.swiper-button-next');
        const nextActionButton: HTMLElement|null = document.querySelector('.swiper-button-next-action');
        const prevSlideButton: HTMLElement|null = document.querySelector('.swiper-button-prev');
        const prevActionButton: HTMLElement|null = document.querySelector('.swiper-button-prev-action');
        const swiperNavigation = document.querySelector('.swiper-navigation');
        const currentNote = swiperNavigation?.querySelector('.current__count');
        const totalNote = swiperNavigation?.querySelector('.total__count');
        const totalDescription = swiperNavigation?.querySelector('.total__description');

        currentNote && (currentNote.innerHTML = '0' + currentSlide.toString())
        totalNote && (totalNote.innerHTML = '0' + slidesCount.toString())
    
        if (swiper.isEnd) {
            // @ts-expect-error hostEl not part of swiper
            totalDescription && (totalDescription.innerHTML = swiper.hostEl.dataset.lastSlideText)
            totalNote && (totalNote.innerHTML = "")
            nextSlideButton && (nextSlideButton.style.display = 'none');
            nextActionButton && (nextActionButton.style.display = 'flex');
        } else {
            totalDescription && (totalDescription.innerHTML = "")
            nextSlideButton && (nextSlideButton.style.display = 'flex');
            nextActionButton && (nextActionButton.style.display = 'none');
        }
        if (swiper.isBeginning) {
            prevSlideButton && (prevSlideButton.style.display = 'none');
            prevActionButton && (prevActionButton.style.display = 'flex');
        } else {
            prevSlideButton && (prevSlideButton.style.display = 'flex');
            prevActionButton && (prevActionButton.style.display = 'none');
        }
        const leadmanagementSliderSlideChangeEvent = new CustomEvent('leadmanagement-slider-slide-change');
        // @ts-expect-error hostEl not part of swiper
        swiper.hostEl.dispatchEvent(leadmanagementSliderSlideChangeEvent);
        // @ts-expect-error hostEl not part of swiper
        swiper.hostEl.scrollIntoView()
    },
}
SbkLeadmanagementSlider.initialize();
export default SbkLeadmanagementSlider;
